import en from './en';
import zh from './zh';
import { createI18n } from 'vue-i18n'; //引入vue-i18n组件
const i18n = createI18n({
  fallbackLocale: 'en',
  globalInjection: true,
  legacy: false, // you must specify 'legacy: false' option
  locale: 'en',
  messages: { zh, en },
});

export default i18n;
